module.exports = function() {
  return new Worker(__webpack_public_path__ + "57142a83f77b76bd7140.worker.js");
};